import { SyntheticEvent, useEffect, useRef, useState } from "react";

import { CHAT_FRAME_SRCDOC, DIGITALK_FRAME_ID } from "./constants";
import { ChatFrame, ChatFrameState } from "./styles";
import { injectChatScript, isChatOpen } from "./utils";

const DigitalkChat = () => {
  const [frameState, setFrameState] = useState<ChatFrameState>("loading");
  const observerRef = useRef<MutationObserver>();

  useEffect(() => () => observerRef.current?.disconnect(), []);

  const handleFrameLoad = (event: SyntheticEvent<HTMLIFrameElement>) => {
    const frameDocument = event.currentTarget.contentDocument;
    if (!frameDocument) return;

    injectChatScript(frameDocument);

    const syncFrameState = () =>
      setFrameState(isChatOpen(frameDocument) ? "open" : "closed");

    observerRef.current = new MutationObserver(syncFrameState);
    observerRef.current.observe(frameDocument.body, {
      childList: true,
      subtree: true,
    });
    syncFrameState();
  };

  return (
    <ChatFrame
      id={DIGITALK_FRAME_ID}
      title="Atendimento"
      srcDoc={CHAT_FRAME_SRCDOC}
      onLoad={handleFrameLoad}
      $state={frameState}
    />
  );
};

export default DigitalkChat;
